export const HOME_TITLE =
  "Jobs - Job Vacancy - Recruitment - Job opportunities - jobhai.com";
export const HEADING = "Find jobs with better salary in Delhi NCR";
export const SUBHEADING = "Call recruiters directly to get job for FREE!";
export const BROWSEBYCAT = "Post a job for below Categories";
export const JOBSBYLOCATION = "Jobs by Location";
export const FEEDBACK_HEADING =
  "You matter to us a lot and so does having a suggestion from you";
export const DOWNLOAD_HEADING = "Get real time updates on your hiring";
export const TWITTER_LINK = "https://twitter.com/officialjobhai";
export const FB_LINK = "https://www.facebook.com/jobhaiofficial";
export const INSTA_LINK = "https://www.instagram.com/jobhaiofficial";

export const HIRING_SOLUTIONS_HEADING =
  "We have made all our hiring solutions FREE";
export const HIRING_SOLUTIONS_SUB_HEADING = `This is how we are helping companies to close their hirings -`;

export const solutionsList = [
  {
    title: "Round the clock support",
    sub_title: "To close your hiring requirement",
    image_source: "/hire/clock.svg"
  },
  {
    title: "Screening jobseekers",
    sub_title: "To save hiring time for our recruiters",
    image_source: "/hire/completed-task.svg"
  },
  {
    title: "Checking jobseekers interest",
    sub_title: "In the job before hand to reduce drop offs at a later stage",
    image_source: "/hire/interest.svg"
  },
  {
    title: "Conducting video interviews",
    sub_title: "Between recruiters and jobseekers",
    image_source: "/hire/videocall.svg"
  }
];

export const ourProductList = [
  {
    title: "Naukri",
    url: "https://www.naukri.com/",
    image_source: "/hire/partner-logo/naukri-new.svg",
    no_follow: false,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "102",
    mobile_width: "77"
  },
  {
    title: "JeevanSathi",
    url: "https://www.jeevansathi.com/",
    image_source: "/hire/partner-logo/jeevansathi.png",
    no_follow: true,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "77",
    mobile_width: "58"
  },
  {
    title: "99acres",
    url: "https://www.99acres.com",
    image_source: "/hire/partner-logo/99acres.svg",
    no_follow: true,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "62",
    mobile_width: "46"
  },
  {
    title: "shiksha",
    url: "https://www.shiksha.com/",
    image_source: "/hire/partner-logo/shiksha.svg",
    no_follow: true,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "56",
    mobile_width: "42"
  },
  {
    title: "Shiksha Online",
    url: "https://www.shiksha.com/online-courses/",
    image_source: "/hire/partner-logo/shiksha-online.png",
    no_follow: false,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "57",
    mobile_width: "43"
  },
  {
    title: "NaukriFastForward",
    url: "https://resume.naukri.com/",
    image_source: "/hire/partner-logo/naukri-fast-forward-new.svg",
    no_follow: false,
    desktop_height: "25",
    mobile_height: "20",
    desktop_width: "89",
    mobile_width: "71"
  },
  {
    title: "FirstNaukri",
    url: "https://www.firstnaukri.com/",
    image_source: "/hire/partner-logo/naukri-learning-new.svg",
    no_follow: false,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "102",
    mobile_width: "77"
  },
  {
    title: "AmbitionBox",
    url: "https://www.ambitionbox.com/",
    image_source: "/hire/partner-logo/ambition-box.png",
    no_follow: true,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "102",
    mobile_width: "77"
  },
  {
    title: "Bigshyft",
    url: "https://www.bigshyft.com/",
    image_source: "/hire/partner-logo/big-shyft.svg",
    no_follow: true,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "90",
    mobile_width: "68"
  },
  {
    title: "Techminis",
    url: "https://techminis.com/",
    image_source: "/hire/partner-logo/techminis.svg",
    no_follow: true,
    desktop_height: "20",
    mobile_height: "15",
    desktop_width: "102",
    mobile_width: "77"
  }
];
